import { axiosClient } from "../axios";

const baseUrl = "/api/registry";

export function createUser(firmId, data) {
  return axiosClient.post(`${baseUrl}/firms/${firmId}/users`, data);
}
